import { styled } from '@mui/material/styles';

export const StyledCheckboxLabel = styled('label')({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
});

export const StyledCheckboxInput = styled('input')({
  marginRight: '8px',
});
